import service from '@/utils/server';

const modName='/fm/fmPageOp/';
//
export const getPageOpList = data => {
  return service({
    url: modName+'pageInfo',
    method: 'post',
    data
  })
};
//
export const getSavePageOp = data => {
  return service({
    url: modName+'add',
    method: 'post',
    data
  })
};

//
export const getUpdatePageOp = data => {
  return service({
    url: modName+'update',
    method: 'post',
    data
  })
};
//
export const getDeletePageOp = data => {
  return service({
    url: modName+'delete/'+data.pageOpId,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/auth/pageOp/api/index.js